import { Trans, useTranslation } from 'react-i18next';
import { getFullname } from '@/helpers/utils';
import { useGetMe } from '@/hooks/useGetMe';
import s from './index.module.scss';

export const ImportantNotes = () => {
  const { t } = useTranslation();
  const { user } = useGetMe();

  return (
    <div className={s.wrapper}>
      <div className="f-headline-2xs f-500">
        {t('funds:important_notes.title')}
      </div>
      <div className={s.notes}>
        <div className="f-body-sm">
          <Trans
            ns="funds"
            i18nKey="important_notes.account_currency"
            components={{
              Span: <span className="f-500" />,
            }}
          />
        </div>
        <div className="f-body-sm">
          <Trans
            ns="funds"
            i18nKey="important_notes.name_matching"
            values={{ name: getFullname(user?.first_name, user?.last_name) }}
            components={{
              Span: <span className="f-500" />,
            }}
          />
        </div>
        <div className="f-body-sm">
          <Trans
            ns="funds"
            i18nKey="important_notes.transfer_fee"
            components={{
              Span: <span className="f-500" />,
            }}
          />
        </div>
        <div className="f-body-sm">
          <Trans
            ns="funds"
            i18nKey="important_notes.processing_time"
            components={{
              Span: <span className="f-500" />,
            }}
          />
        </div>
      </div>
    </div>
  );
};